import React from 'react'
import { useHistory } from 'react-router'

import { bemJoin } from 'bem-join'

import { FormattedError } from '@app/common/Components/FormattedError'
import {
  AlertType,
  useNotifications
} from '@app/common/services/Notifications/NotificationsProvider'
import { useIntl } from '@app/intl/Intl'
import { Button } from '@app/lib/inputs/Button/Button'
import { Text } from '@app/lib/typography/Text/Text'
import { getAuditReportsPath } from '@app/modules/AuditReports/paths'
import { useSendSuggestAppointmentEmailMutation } from '@app/queries/SendSuggestAppointmentEmail/SendSuggestAppointmentEmail.queries'

import './SuggestPhoneAppointmentForm.scss'

export type Props = {
  onClose: () => void
  messageId: number
}

export const SuggestPhoneAppointmentForm = ({ onClose, messageId }: Props) => {
  const b = bemJoin('suggest-phone-appointment-form')
  const { formatMessage } = useIntl()
  const { pushNotification } = useNotifications()
  const history = useHistory()

  const [suggestAppointment, { loading }] = useSendSuggestAppointmentEmailMutation({
    onError: (error) => {
      pushNotification({
        type: AlertType.error,
        message: <FormattedError error={error} />
      })
    },
    onCompleted: () => {
      history.push(getAuditReportsPath())
    }
  })

  const onSubmit = async () => {
    await suggestAppointment({
      variables: { input: { messageId } }
    })
  }

  return (
    <div>
      <Text justification={'center'}>
        {formatMessage({ id: 'SuggestPhoneAppointment.Form.Content' })}
      </Text>
      <div className={b('button-group')}>
        <Button color={'danger'} variant={'solid'} size={'sm'} onClick={onClose}>
          {formatMessage({ id: 'SuggestPhoneAppointment.Form.CancelButton' })}
        </Button>
        <Button
          color={'primary'}
          variant={'solid'}
          size={'sm'}
          onClick={onSubmit}
          loading={loading}
        >
          {formatMessage({ id: 'SuggestPhoneAppointment.Form.ConfirmButton' })}
        </Button>
      </div>
    </div>
  )
}
